import HmEventRegistry from './../model/HmEventRegistry';
import HmAjax from './../util/HmAjax';
import NativeAjax from './../util/NativeAjax';
import UrlManager from './../model/UrlManager';
import RbUtil from './../util/RbUtil';
import BrowserUtil from './../util/BrowserUtil';

const AppPrepPunchIn = function(callBack){

	const contestGrpId = (() => {
		let contestId = localStorage.getItem("contestType");
		
		if(!contestId){
			try{
				contestId = window.location.pathname.substr(window.location.pathname.lastIndexOf("/")+1,window.location.pathname.length);
			}catch(e){
				console.error("Error while retrieving the contest grp Id", e);
			}			
		}

		return contestId;		
	})();

	let connectToPLP = (response) => {
		let headersData = {
			"Access-Control-Allow-Origin": "*",
			"Access-Control-Allow-Headers":"*",
			'Content-Type': 'application/json',
			"User-Type":"retail_web",
			"Access-Control-Allow-Credentials": "true"
		};
		new NativeAjax(UrlManager.getUrlForAction("PLP_PREP_ACCESS_CHECK").replace("{#contestId}", contestGrpId)).setHeaders(headersData).enableCORS().mask().setHeaders(headersData).get((resp) => {
			if(resp && resp.status === "success"){
				//localStorage.setItem("loginVia",window.location.hostname);
                callBack.apply(this);
                window.location.href = resp.url;
			}else if(resp && resp.status !== "success"){
				let errMsg = (resp.errMsg) ? "prep.err." + resp.errMsg.toLowerCase() : null;
				promptError(errMsg);
			}else{
				//contest_in_progress
			}
		}, (err) => {
			promptError("503.msg","503","503.title");
			console.error("Error occurred :: ", err);
		});	
	}

	let promptError = (errMsg, statusCode,title) =>{
		let errObj = {
			"status_code":statusCode || "403",
			"msg": errMsg ? RbUtil.getText(errMsg) : RbUtil.getText("service.unavailable.yet"),
			"title": title
		};

		HmEventRegistry.fireEvent("ERROR_PROMPT",errObj);
	}
	
	let success = (resp) => {
		if(resp && resp.valid){
           
			connectToPLP(resp);
			//window.open(UrlManager.getUrlForAction("PREP_PUNCHIN_LUMOS").replace("{userId}",resp.uId),"_blank");
		}else if(resp && !resp.valid){
			let errMsg = (resp.errMsg) ? "prep.err." + resp.errMsg.toLowerCase() : null;
			promptError(errMsg);
		}else{
			//Do nothing now
		}
		
	}

	let failure = (err) => {
		promptError("503.msg","503","503.title");
		console.error("Error occurred :: ", err);
	}

	// if(contestGrpId){
	// 	let headersData = {
	// 		"User-Type":"retail_web"
	// 	};
	// 	let data = {

	// 	}
	// 	new HmAjax(UrlManager.getUrlForAction("APP_PREP_ACCESS_CHECK").replace("{#contestId}", contestGrpId)).mask().get(success, failure);	
	// }else{
	// 	console.error("contestGrpId not retrieved :: ", contestGrpId);
	// }
	
	connectToPLP()
}

export default AppPrepPunchIn;

HmEventRegistry.registerEvent("app_prep",function(callBack){
	new AppPrepPunchIn(callBack);
});


// WEBPACK FOOTER //
// ./src/vendors/AppPrepPunchIn.js